import{mergeMap as n}from"./mergeMap.js";function r(r,t,e){return void 0===e&&(e=Number.POSITIVE_INFINITY),"function"==typeof t?n((function(){return r}),t,e):("number"==typeof t&&(e=t),n((function(){return r}),e))}export{r as mergeMapTo};
